// Menu principal. Chaque entrée n'apparaît que si l'utilisateur possède la
// permission de consultation (issue de /auth/me) : on ne raisonne jamais sur
// le nom du rôle.

export const NAV_SECTIONS = [
  {
    title: 'Opérations',
    items: [
      { label: 'Tableau de bord', to: '/dashboard', icon: 'dashboard', permission: 'dashboard.view' },
      { label: 'Types de véhicules', to: '/vehicle-types', icon: 'tag', permission: 'vehicle_types.view' },
      { label: 'Propriétaires', to: '/owners', icon: 'home', permission: 'owners.view' },
      { label: 'Chauffeurs', to: '/drivers', icon: 'driver', permission: 'drivers.view' },
      { label: 'Véhicules', to: '/vehicles', icon: 'vehicle', permission: 'vehicles.view' },
      { label: 'Maintenance', to: '/maintenance', icon: 'wrench', permission: 'maintenance_records.view', match: '/maintenance' }
    ]
  },
  {
    title: 'Finances',
    items: [
      { label: 'Recettes', to: '/revenues', icon: 'revenue', permission: 'revenues.view' },
      { label: 'Dépenses', to: '/expenses', icon: 'expense', permission: 'expenses.view', match: '/expenses' },
      { label: 'Carburant', to: '/fuel', icon: 'fuel', permission: 'fuel_logs.view', match: '/fuel' },
      { label: 'Versements', to: '/payments', icon: 'wallet', permission: 'payments.view' },
      { label: 'Rapprochement', to: '/reconciliation', icon: 'scale', permission: 'reconciliation.view' },
      // Permission « salaries.view » non confirmée par le brief (page résumée, pas de détail) :
      // on s'appuie sur « revenues.view », déjà utilisée pour « Recettes » et que le chauffeur
      // possède forcément (il saisit ses propres recettes) — contrairement à « drivers.view »,
      // réservée au personnel. Le chauffeur ne voit alors que sa propre ligne (filtrage serveur,
      // comme partout ailleurs) ; le sélecteur de chauffeur reste réservé à qui a « drivers.view ».
      // Le serveur reste la référence : GET /salaries répondra son propre 403 si besoin.
      { label: 'Salaires', to: '/salaries', icon: 'percent', permission: 'revenues.view' }
    ]
  },
  {
    title: 'Analyse',
    items: [{ label: 'Rapports', to: '/reports', icon: 'chart', permission: 'reports.view' }]
  },
  {
    title: 'Administration',
    items: [
      { label: 'Utilisateurs', to: '/users', icon: 'users', permission: 'users.view' },
      { label: 'Rôles', to: '/roles', icon: 'key', permission: 'roles.view' },
      { label: "Journal d'audit", to: '/audit', icon: 'shield', permission: 'audit.view' }
    ]
  }
]

export function firstAccessiblePath(can) {
  for (const section of NAV_SECTIONS) {
    for (const item of section.items) {
      if (can(item.permission)) return item.to
    }
  }
  return '/notifications'
}
